import { InstallationPoint } from '../../../../../../app/entities/InstallationPoint'
import { ILocation } from '../../../../../../app/entities/Location'
import {
  GEOCODE_ZIP_CODE,
  GEOCODE_STATE,
  GEOCODE_CITY,
  GEOCODE_STREET_ADDRESS,
  GEOCODE_STREET_NUMBER,
  GEOCODE_STREET_NAME,
  GEOCODE_NON_STANDARD_ADDRESS,
} from '../../../constants/google-maps-address'
import { fetchData } from '../../fetch'
import { getDirections } from './api'
import { GeocoderResult, GeocoderAddressComponent } from '../../../types/google-maps-address'

function findAddressComponentMatchingFirstType(
  addressComponent: GeocoderAddressComponent[],
  geocodePlaceTypesArray: string[],
): GeocoderAddressComponent | undefined {
  for (const type of geocodePlaceTypesArray) {
    for (const component of addressComponent) {
      if (component.types.includes(type)) {
        return component
      }
    }
  }
}

async function fetchDrivingDetails(
  chosenAddress: GeocoderResult | null,
  locationObjectId: string,
) {
  try {
    const drivingDetails = await fetchData<{
      distance: { text: string; value: number }
      duration: { text: string; value: number }
      end_location: { lat: number; lng: number }
      start_location: { lat: number; lng: number }
    }>(
      getDirections(
        locationObjectId,
        chosenAddress?.geometry.location.lat ?? 0,
        chosenAddress?.geometry.location.lng ?? 0,
      ),
    )

    if (!drivingDetails.distance || !drivingDetails.duration) {
      return
    }

    return drivingDetails
  } catch {
    return
  }
}

async function createInstallationPointFromGeocode(
  currentChosenAddress: GeocoderResult,
  locationObjectId: string,
): Promise<Partial<InstallationPoint>> {
  const { address_components: addressComponents } = currentChosenAddress
  const zipCode =
    findAddressComponentMatchingFirstType(addressComponents, GEOCODE_ZIP_CODE)
      ?.long_name ?? ''
  const state =
    findAddressComponentMatchingFirstType(addressComponents, GEOCODE_STATE)
      ?.short_name ?? ''
  const city =
    findAddressComponentMatchingFirstType(addressComponents, GEOCODE_CITY)
      ?.long_name ?? ''
  let streetAddress =
    findAddressComponentMatchingFirstType(
      addressComponents,
      GEOCODE_STREET_ADDRESS,
    )?.long_name ?? ''
  const streetNumber =
    findAddressComponentMatchingFirstType(
      addressComponents,
      GEOCODE_STREET_NUMBER,
    )?.long_name ?? ''
  const streetName =
    findAddressComponentMatchingFirstType(
      addressComponents,
      GEOCODE_STREET_NAME,
    )?.long_name ?? ''
  const nonStandardAddress =
    findAddressComponentMatchingFirstType(
      addressComponents,
      GEOCODE_NON_STANDARD_ADDRESS,
    )?.long_name ?? ''

  if (streetAddress.length === 0) {
    if (streetNumber.length === 0 || streetName.length === 0) {
      //google maps can still find nonStandard addresses, but we would like to not use them if we can help it
      streetAddress = nonStandardAddress
    }
    streetAddress = `${streetNumber} ${streetName}`
  }

  const drivingDetails = await fetchDrivingDetails(
    currentChosenAddress,
    locationObjectId,
  )
  const installationPoint: Partial<InstallationPoint> = {
    zipCode: zipCode,
    state: state,
    city: city,
    address: streetAddress,
    drivingDetails,
  }
  return installationPoint
}

export default createInstallationPointFromGeocode
